import * as React from 'react';
import { PureIconContainer } from './utils/IconContainer';
var QuestionCircleFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_QuestionCircleFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-7.5 3.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-2-5.06C6.5 5.658 7.157 5 8 5s1.5.659 1.5 1.44c0 .535-.306 1.01-.774 1.26-.517.275-1.226.829-1.226 1.679V9.5a.5.5 0 0 0 1 0v-.121c0-.255.239-.553.696-.797A2.431 2.431 0 0 0 10.5 6.439C10.5 5.078 9.366 4 8 4S5.5 5.078 5.5 6.44a.5.5 0 1 0 1 0Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_QuestionCircleFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
export default QuestionCircleFill;